export class ConfettiAnimation {
    constructor() {}

    /**
     *
     * @param {Number} options.timing - Time in seconds for the animation to run.
     * @param {Array} options.shapes - Array of shapes to use in the animation.
     * @param {Array} options.colors - Array of colors to use in the animation.
     */
    fireworks(options = {}) {
        const timing = options?.timing || 5;
        const duration = timing * 1000,
            animationEnd = Date.now() + duration,
            defaults = {
                startVelocity: 30,
                spread: 360,
                ticks: 60,
                zIndex: options.zIndex,
                shapes: options?.shapes || ["circle", "square"],
                colors: options?.colors || []
            };
        const randomInRange = (min, max) => {
            return Math.random() * (max - min) + min;
        };
        const interval = setInterval(() => {
            const timeLeft = animationEnd - Date.now();
            if (timeLeft <= 0) {
                return clearInterval(interval);
            }
            const particleCount = 50 * (timeLeft / duration);
            confetti(
                Object.assign({}, defaults, {
                    particleCount,
                    origin: {
                        x: randomInRange(0.1, 0.3),
                        y: Math.random() - 0.2
                    }
                })
            );
            confetti(
                Object.assign({}, defaults, {
                    particleCount,
                    origin: {
                        x: randomInRange(0.7, 0.9),
                        y: Math.random() - 0.2
                    }
                })
            );
        }, 250);
    }
}
